import {colors, Modal, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import GroupMemberAdjustmentEdit from './GroupMemberAdjustmentEdit';
import {GroupMember, GroupMemberAdjustment} from '../../../graphql/groups.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '90%',
        overflowY: 'auto',
        maxWidth: '95%'
    },
    container: {
        marginTop: theme.spacing(3)
    },
    actions: {
        justifyContent: 'flex-end'
    },
    deleteButton: {
        color: theme.palette.white,
        backgroundColor: colors.red[600],
        '&:hover': {
            backgroundColor: colors.red[900]
        }
    },
    submitButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        }
    }
}));

const GroupMemberAdjustmentModal = (props: {
    className?: string,
    onClose: () => void,
    open: boolean,
    groupMember: GroupMember,
    adjustment: GroupMemberAdjustment,
    setSelectedAdjustment?: (adjustment: GroupMemberAdjustment | null) => void,
    isAdmin: boolean,
}) => {
    const {open, onClose, groupMember, adjustment, setSelectedAdjustment, isAdmin} = props;
    const classes = useStyles();

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={onClose} open={open}>
            <React.Fragment>
                <GroupMemberAdjustmentEdit className={clsx(classes.root)} groupMember={groupMember}
                                           adjustment={adjustment} setSelectedAdjustment={setSelectedAdjustment}
                                           isAdmin={isAdmin}/>
            </React.Fragment>
        </Modal>
    );
};

export default GroupMemberAdjustmentModal;
